export default "__VITE_ASSET__Wt52txu4__"